import { FormProps } from '@alphabait/ui/form'
import cx from 'classnames'
import { useEffect, useState } from 'react'
import i18n from '../../i18n'
import { AlphaTypes, RadioGroupGenderInput } from './custom-types'
import style from './form.module.css'

export default function RadioGroupGender({
  field,
  formProps,
}: {
  field: RadioGroupGenderInput
  formProps: FormProps
}) {
  const [isSelected, setIsSelected] = useState<string>()
  useEffect(() => {
    setIsSelected(field.value)
  }, [field.value])

  return (
    <>
      <div className="flex flex-row gap-4 pl-1.5 pt-4">
        <label
          htmlFor={`${field.name}-man`}
          onClick={() => setIsSelected('man')}
          className={cx(
            style.radioGender,
            'radioGenderClient',
            `${
              isSelected === 'man' &&
              'border border-primary bg-primary text-white'
            }`,
          )}
          data-testid={`${field.uiOptions?.testId ?? field.name}-man`}
        >
          <input
            {...formProps.register(field.name)}
            type="radio"
            value="man"
            checked={field.value === 'man'}
            className="sr-only"
            id={`${field.name}-man`}
            data-testid={`${field.uiOptions?.testId ?? field.name}-man-input`}
          />
          <span className="font-bold text-gray-200">{'Man'}</span>
        </label>
        <label
          htmlFor={`${field.name}-woman`}
          onClick={() => setIsSelected('woman')}
          className={cx(
            style.radioGender,
            'radioGenderClient',
            `${
              isSelected === 'woman' &&
              'border border-primary bg-primary text-white'
            }`,
          )}
          data-testid={`${field.uiOptions?.testId ?? field.name}-woman`}
        >
          <input
            {...formProps.register(field.name, {
              required: field.validations?.includes('required'),
            })}
            type="radio"
            value="woman"
            checked={field.value === 'woman'}
            className="sr-only"
            id={`${field.name}-woman`}
            data-testid={`${field.uiOptions?.testId ?? field.name}-woman-input`}
          />
          <span className="font-bold text-gray-200">{'Vrouw'}</span>
        </label>
        <label
          htmlFor={`${field.name}-different`}
          onClick={() => setIsSelected('different')}
          className={cx(
            style.radioGender,
            'radioGenderClient',
            `${
              isSelected === 'different' &&
              'border border-primary bg-primary text-white'
            }`,
          )}
          data-testid={`${field.uiOptions?.testId ?? field.name}-different`}
        >
          <input
            {...formProps.register(field.name, {
              required: field.validations?.includes('required'),
            })}
            type="radio"
            value="different"
            checked={field.value === 'different'}
            className="sr-only"
            id={`${field.name}-different`}
            data-testid={`${
              field.uiOptions?.testId ?? field.name
            }-different-input`}
          />
          <span className="font-bold text-gray-200">{'Anders'}</span>
        </label>
      </div>
    </>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const getCustomRadioGenderProperties = () =>
  [
    {
      name: 'uiOptions.label',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.question'),
        inputType: 'text',
      },
      validations: ['required'],
    },
    {
      name: 'validation.required',
      customControlType: 'switch',
      type: 'custom',
      uiOptions: {
        label: i18n.t('questionnaire_builder.required'),
      },
    },
  ] as AlphaTypes[]
